import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import MapMarker from '../components/map_marker';
import SelectedMarker from '../components/selected_marker';
import RestaurantMarker from '../components/restaurant_marker';
import { destination } from '../components/map_center';

// Return map bounds based on list lat lngs.
const getMapBounds = (map, maps, results) => {
  const bounds = new map.LatLngBounds();
  results.forEach((result) => {
    bounds.extend(new map.LatLng(
      result.latitude,
      result.longitude,
    ));
  });
  return bounds;
};

// Re-center map when resizing the window
const bindResizeListener = (maps, map, bounds) => {
  maps.event.addDomListenerOnce(map, 'idle', () => {
    maps.event.addDomListener(window, 'resize', () => {
      map.fitBounds(bounds);
    });
  });
};

// Fit map to its bounds after the api is loaded
const apiIsLoaded = (maps, map, results) => {
  // Get bounds by our places
  const bounds = getMapBounds(map, maps, results);
  // Fit map to bounds
  maps.fitBounds(bounds);
  // Bind the resize listener
  bindResizeListener(map, maps, bounds);
};

class MapContainer extends Component {
  constructor(props) {
    super(props);
    var nav_selection = props.data.nav_selection
    var results = props.data.results
    var hotel_favs = props.data.hotel_favs
    var restaurant_favs = props.data.restaurant_favs
    var attraction_favs = props.data.attraction_favs
    this.state = {
      results: results,
      query_terms: props.data.query_terms,
      hotel_favs: hotel_favs,
      restaurant_favs: restaurant_favs,
      attraction_favs: attraction_favs,
      nav_selection: nav_selection,
      center: {
        lat: destination[0],
        lng: destination[1]
      },
      zoom: 13,
      key: { key: process.env.REACT_APP_MAP_API_KEY },
      clickedKey: ""
    };
  }

  getMapsOnApiLoad(map, maps){
    this.setState({
      map: map,
      maps: maps
    })
  }

  UNSAFE_componentWillReceiveProps(props) {
    const hotel_favs = props.data.hotel_favs
    const restaurant_favs = props.data.restaurant_favs
    const attraction_favs = props.data.attraction_favs
    const nav_selection = props.data.nav_selection
    const props_results = props.data.results
    const maps = this.state.maps
    const map = this.state.map

    //map only recenters and finds bounds when new results come in.
    if(this.state.results === props_results || this.state.query_terms.length === 0){
      this.setState({ center: this.state.center } )
    } else {
      if((map && maps) && hotel_favs && nav_selection !== "hotels"){
        const all_map_points = [...hotel_favs,...props_results]
        apiIsLoaded(map, maps, all_map_points)
      } else {
        if(map && maps){
          apiIsLoaded(map, maps, props_results)
        }
      }
    }

    this.setState({
      hotel_favs: hotel_favs,
      restaurant_favs: restaurant_favs,
      attraction_favs: attraction_favs,
      results: props_results,
      nav_selection: nav_selection
    },
    ()=> {console.log(this.state.nav_selection, this.state.hotel_favs, this.state.attraction_favs, this.state.restaurant_favs, this.state.results)}
    );

  }

  onChildClick(key, props) {
    const { lat } = props
    const { lng } = props

    this.setState({
      center:{
        lat: lat,
        lng: lng
      },
      zoom: 16,
      clickedKey: key
    })
  }

  _onChange = ({center, zoom}) => {
    this.setState({
      center: center,
      zoom: zoom,
    });
  }



  render() {
    var restaurants = {};
    var restArray = [];
    return(
      <div style = {{ height: '100%', width:'100%'}}>
      <GoogleMapReact
      bootstrapURLKeys= { this.state.key }
      center= { this.state.center }
      zoom={ this.state.zoom }
      onChange={this._onChange.bind(this)}
      yesIWantToUseGoogleMapApiInternals = {true}
      onChildClick = { this.onChildClick.bind(this) }
      onGoogleApiLoaded = {({ map, maps }) =>
      {  this.getMapsOnApiLoad(map, maps) }  }
      >
        { this.state.results.map(mark => {
          if(mark.nearby_restaurants){
            for(let i = 0; i < mark.nearby_restaurants.length; i++){
              const rest = mark.nearby_restaurants[i];
              const key = rest["entity_id"];
              restaurants[key] = rest;
            }
          }
          restArray = Object.values(restaurants)

          if(this.state.clickedKey === mark.entity_id){
            return (
              <SelectedMarker
              key= {mark.entity_id}
              name= {mark.name}
              lat= {mark.latitude}
              lng= {mark.longitude}
              type= {mark.business_type}
              />
            )
          }
          return (
            <MapMarker
            key= { mark.entity_id }
            name= { mark.name }
            lat= { mark.latitude }
            lng= { mark.longitude }
            type= {mark.business_type}
            />
          )
        }
      )}

      { this.state.clickedKey && this.state.zoom >= 13 && restArray.map( (rest) => {
        return(
          <RestaurantMarker
          key= {rest.entity_id}
          name={rest.name}
          lat= {rest.latitude}
          lng= {rest.longitude}
          type= {rest.business_type}
          />
          )
        })
      }

      {this.state.hotel_favs && this.state.hotel_favs.map((hotel) => {
        if(this.state.nav_selection !== "hotels"){
          return(
            <MapMarker
            key = {hotel.entity_id}
            name ={hotel.name}
            lat = {hotel.latitude}
            lng ={hotel.longitude}
            type ={hotel.business_type}
            />
          )}

        })
      }

      </GoogleMapReact>
    </div>);
    }
}

export default MapContainer;
